import React, { useState } from 'react';
import { Video } from 'react-feather';
import PropTypes from 'prop-types';

import VideoRecord from 'components/VideoRecord/VideoRecord';
import fileApi from 'api/fileApi';
import ButtonAction from './ButtonAction';
import { handleToastError } from 'helpers';
import LoadingOverlay from 'react-loading-overlay';

const RecordVideo = ({
  type,
  setType,
  onSubmitCompleteUnit,
  setIntervalFunc,
  isDisabled,
}) => {
  const [isLoading, setIsLoading] = useState(false);
  const [progressOrder, setProgressOrder] = useState(undefined);

  const handleUploadFile = async (file, index) => {
    try {
      setProgressOrder(index);
      const config = {
        onUploadProgress: (progressEvent) => {
          const percentCompleted = Math.round(
            (progressEvent?.loaded * 100) / progressEvent?.total,
          );
          const progress = document.getElementById(
            `progress-upload-file-${index}`,
          )?.firstElementChild;

          if (progress) {
            progress.style.width = `${percentCompleted}%`;
          }
        },
      };
      const formData = new FormData();
      formData.append('users-file', file);
      const fileUploaded = await fileApi.uploadUserFile(formData, config);
      return fileUploaded;
    } catch (error) {
      showToastError('Error while uploading a video');
    }
  };
  const handleSubmit = async (files) => {
    try {
      setIsLoading(true);
      const promise = [];
      for (let i = 0; i < files.length; i++) {
        const item = files[i];
        let result = await handleUploadFile(item, i);
        promise.push(result);
      }

      const dataFiles = await Promise.all(promise);
      const arrIds = dataFiles.map((item) => item?._id);
      await onSubmitCompleteUnit({ _id: arrIds }, dataFiles);
    } catch (e) {
      handleToastError(e);
    } finally {
      setProgressOrder(undefined);
      setIsLoading(false);
    }
  };

  return (
    <LoadingOverlay
      active={isLoading}
      spinner
      styles={{
        overlay: (base) => ({
          ...base,
          background: 'rgb(187 181 181 / 50%)',
        }),
      }}
    >
      <div>
        {type === 'VIDEO' && (
          <>
            <VideoRecord
              titleSubmit="Upload your reply"
              type={type}
              progressOrder={progressOrder}
              onCancel={() => setType('')}
              onSubmit={handleSubmit}
              isLoading={isLoading}
            />
          </>
        )}
        {!type && (
          <ButtonAction
            disabled={isDisabled}
            icon={<Video />}
            text="Record video"
            onClick={() => {
              setType('VIDEO');
              setIntervalFunc();
            }}
          />
        )}
      </div>
    </LoadingOverlay>
  );
};

RecordVideo.propTypes = {
  type: PropTypes.string.isRequired,
  setType: PropTypes.func.isRequired,
  onSubmitCompleteUnit: PropTypes.func.isRequired,
};

export default RecordVideo;
